<template>
    <div>
        <app-header></app-header>
        <main id="page-main" class="with-tabs">
            <nav>
                <ul>
                    <li><router-link :to="{ name: 'reservation' }"><i class="icon icon-icon_users"></i> Reservation</router-link></li>
                </ul>
            </nav>
            <router-view></router-view>
        </main>
    </div>
</template>
<script>

    export default {
        name: 'Checkin',
        data () {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/checkin/Index.vue